import { CodeComplexValue } from 'app/area/shared/codetable/types';

export const breadcrumbsValidPath = (breadcrumbsOptions: CodeComplexValue<number>[] = []): boolean => {

  const allDescendants = breadcrumbsOptions.filter(option => option.descendants);
  const descendants = allDescendants.pop()?.descendants;
  const childValue = breadcrumbsOptions.find(option => !option.descendants)?.value;

  return !!(descendants?.some(descendant => descendant.value === childValue));
};
